import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { LinkedinModel } from './linkedin.model';
import { CommonService } from '../common.service';

@Injectable()
export class LinkedinService {

  public linkedinSubject: BehaviorSubject<LinkedinModel>;

  constructor(private cs: CommonService) {
    this.linkedinSubject = new BehaviorSubject({ id: '', firstName: '', lastName: '', photo: '', isAuth: false });
  }

  loginLinkedin() {
    this.cs.nativeWindow.IN.User.authorize(() => {
      this.cs.nativeWindow.IN.API.Raw('/people/~:(id,first-name,last-name,public-profile-url,picture-url)?format=json')
        .result((data) => {
          this.linkedinSubject.next({
            id: data.id,
            firstName: data.firstName,
            lastName: data.lastName,
            photo: data.pictureUrl,
            isAuth: this.cs.nativeWindow.IN.User.isAuthorized()
          });
        });
    }, this);
  }

  api(params: string, method: string = 'GET', body: any = {}) {
    return this.cs.nativeWindow.IN.API.Raw(params + '?format=json')
      .method(method)
      .body(body)
      .result((data) => data);
  }

}







// WEBPACK FOOTER //
// ./src/app/social/linkedin/linkedin.service.ts